<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#63BCF8" type="ball-atom"></ngx-spinner>
<!----- HEADER ----->
<mat-toolbar ng-scroll="onScroll($event)" id="nav">
  <!-- This fills the remaining space of the current row -->
  <span class="example-fill-remaining-space"></span>


  <div class="logodiv">

    <a [routerLink]="[ 'home' ]">
      <img class="menulogo" src="../assets/medias/img/LOGO_contrast.webp" alt="edclin">
    </a>
  </div>


  <div class="__nav-item">
    <div id="menu">
      <mat-menu #menu1="matMenu">
        <button id="pannelBtn1" mat-menu-item>
          <a target="_blank"
            href="https://xd.adobe.com/view/31311a86-bb95-4999-5a17-2d78c4b30401-4700/?fullscreen">Neuro DM
            observational</a>
        </button>
        <button id="pannelBtn1" mat-menu-item>
          <a target="_blank"
            href="https://xd.adobe.com/view/31311a86-bb95-4999-5a17-2d78c4b30401-4700/?fullscreen">Cardiology
            early-phase</a>
        </button>
      </mat-menu>

      <button mat-button [matMenuTriggerFor]="menu1" class="btn-hover color-3">Launch EDC demo</button>

      <button mat-button class="menu-item"><a href="#/home" routerLink="" routerLinkActive="active">Home</a></button>
      <button mat-button class="menu-item"><a href="#/about" routerLink="/about">About</a></button>
      <button mat-button class="menu-item"><a id="pricing" href="#/pricing" routerLink="/pricing">Pricing</a></button>
      <button mat-button class="menu-item"><a href="#/epro" routerLink="/epro">Patient Apps</a></button>
      <button mat-button class="menu-item"><a href="#/contact" routerLink="/contact-form">Contact</a></button>
    </div>


    <!-- REPONSIVE MENU  -->
    <button id="btn_menu" style="background-color:transparent;" mat-icon-button [matMenuTriggerFor]="menu"
      aria-label="icon-button with a menu">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button [ngStyle]="{'background-color': bgColorButton}">
        <a target="_blank" href="https://xd.adobe.com/view/31311a86-bb95-4999-5a17-2d78c4b30401-4700/?fullscreen">
          <div class="gradient">EDC DEMO | </div>
          Neuro DM observational
        </a></button>
      <button [ngStyle]="{'background-color': bgColorButton}">
        <a target="_blank" href="https://xd.adobe.com/view/31311a86-bb95-4999-5a17-2d78c4b30401-4700/?fullscreen">
          <div class="gradient">EDC DEMO | </div>
          Cardiology early-phase
        </a></button>
      <span mat-menu-item><a href="#/home" routerLink="" routerLinkActive="active">Home</a></span>
      <span mat-menu-item><a href="#/about" routerLink="/about">About</a></span>
      <span mat-menu-item><a href="#/pricing" routerLink="/pricing">Pricing</a></span>
      <span mat-menu-item><a href="#/epro" routerLink="/epro">Patient Apps</a></span>
      <span mat-menu-item><a href="#/contact" routerLink="/contact-form">Contact</a></span>
    </mat-menu>
  </div>
</mat-toolbar>


<div [@routerTransition]="getState(o)">
  <router-outlet #o="outlet"></router-outlet>
</div>

<!----- FOOTER ----->
